import React from 'react';
import { Button } from 'react-bootstrap';
import ClipLoader from "react-spinners/ClipLoader";
import OutletHead from '../../../../components/common/outlet-head';
import { IoCallOutline, IoLogoWhatsapp, IoMailOutline } from 'react-icons/io5';

function HelpSupport() {

  return (
    <section className='section'>
      <OutletHead
        left={
          <div className='custom-header'>
            <h5 className='mb-0 fw-600'>Help & Support</h5>
            <p className='mb-0 text-muted'>
              <small>Find answers for all your doubts</small>
            </p>
          </div>
        }
        right={
          <div className='d-flex align-items-center'>
            <Button
              variant="success"
              className='py-2 btn-width'
              onClick={null}
            >
              Chat with us
            </Button>
          </div>
        }
      />
      <div className='form-wrapper border-top'>
        <div className='row h-100'>
          <div className='col-4'>
            <div className='h-100 px-3'>
              <div className='row'>
                <div className='col-12'>
                  <div className='border overflow-hidden rounded my-3 p-3'>
                    <div className='d-flex align-items-center justify-content-center px-3 py-2 text-muted'>
                      <IoLogoWhatsapp size={36} />
                      <div>
                        <h6 className='mb-0 ms-3'>WhatsApp us</h6>
                        <h6 className='mb-0 ms-3'>
                          <small>+91 7800111018</small>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-12'>
                  <div className='border overflow-hidden rounded my-3 p-3'>
                    <div className='d-flex align-items-center justify-content-center px-3 py-2 text-muted'>
                      <IoCallOutline size={36} />
                      <div>
                        <h6 className='mb-0 ms-3'>Call us</h6>
                        <h6 className='mb-0 ms-3'>
                          <small>+91 7800111018</small>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-12'>
                  <div className='border overflow-hidden rounded my-3 p-3'>
                    <div className='d-flex align-items-center justify-content-center px-3 py-2 text-muted'>
                      <IoMailOutline size={36} />
                      <div>
                        <h6 className='mb-0 ms-3'>E-Mail us</h6>
                        <h6 className='mb-0 ms-3'>
                          <small>support@next2estate.com</small>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-8'>
            <div className='h-100 bg-light overflow-hidden'>
              <iframe title='Query-Form' src="https://docs.google.com/forms/d/e/1FAIpQLScc8DzmQNzVogjHGozhdXRF00PJMzagAdVy3FAVtGXg_crbbw/viewform?embedded=true" width="100%" height="100%" frameborder="0" marginheight="0" marginwidth="0">
                <ClipLoader />
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HelpSupport;